import { Color, PhongSettings, Settings } from '@technology/web3d';
import { ViewerPreferenceSettings } from '@trimble/viewer-preferences';

// Subset of viewer Settings the preferences drive; lets the mapping be
// unit-tested without a live viewer.
export type ViewerPreferenceTarget = Pick<
  Settings,
  'background' | 'color' | 'materialPhong' | 'clippingHighlightColor'
>;

// Assigning each property on the viewer's reactive settings proxy triggers a repaint.
export function applyViewerPreferences(
  settings: ViewerPreferenceTarget,
  preferences: ViewerPreferenceSettings
): void {
  settings.background = {
    topColor: new Color(preferences.backgroundTopColor),
    bottomColor: new Color(preferences.backgroundBottomColor),
  };
  settings.color = new Color(preferences.textColor);
  // materialPhong supersedes the deprecated darkModeMaterials flag in web3d.
  settings.materialPhong = preferences.darkModeMaterials
    ? PhongSettings.DarkMode
    : PhongSettings.Default;
  settings.clippingHighlightColor = new Color(
    preferences.clippingHighlightColor
  );
}
